import { Component, OnInit } from '@angular/core';
import {FormService} from "../../services/form.service";
import {Message, MessageService} from "primeng/api";
import {Router} from "@angular/router";
import {Constants} from "../../types/constants";

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.css']
})
export class SignComponent implements OnInit {
  proposalSignature ?: string;
  proposalId ?: number;
  signAllowed?: boolean;
  companyTypeId ?: string;
  message: Message[] = [
    {severity: "info",
      summary: "Aby dokończyć proces składania wniosku, dokument musi zostać podpisany przez osobę uprawnioną.",
      closable: false
    }];

  constructor(private router: Router,
              private formService: FormService,
              private messageService: MessageService) { }

  ngOnInit(): void {
    this.proposalSignature = this.formService.proposalSignature;
    this.proposalId = this.formService.proposalId;
    if (!this.proposalSignature || !this.proposalId)
      this.router.navigate(["/choose-form"]);
    this.signAllowed = undefined;
    this.companyTypeId = this.formService.companyTypeId;
  }

  signProposal() {
    this.formService.getSigningUrl(this.proposalId!).subscribe({
      next: (response) => {
        window.location.href = response.body;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          detail: Constants.GenericError }
        );
      }
    })
  }

  downloadProposal() {
    this.formService.getDocument(this.proposalId!).subscribe(
      response => {
        if (!response.body || !response.headers) {
          this.messageService.add({
            severity: 'error',
            detail: Constants.GenericError }
          );
          return;
        }

        let contentDisposition = response.headers.get('content-disposition');
        let fileName = this.proposalSignature!;
        if (contentDisposition) {
          fileName = contentDisposition
            .split(';')
            .map(h => h.trim())
            .filter(h => h.startsWith('filename='))
            .reduce(h => h.length === 1 ? h[0] : this.proposalSignature!)
            .replace('filename=', '');
        }
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(response.body)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.messageService.add({
          severity: 'success',
          detail: 'Wniosek został zapisany na Twoim komputerze' }
        );
      },
      error => {
        this.messageService.add({
          severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
          detail: error.error.message ?? Constants.GenericError}
        );
      }
    )
  }

  goToProposalsList(): void {
    this.router.navigate(['/proposals-list']);
  }
}
